import React from "react";
import { BsWhatsapp } from "react-icons/bs";
import "./WhatsAppButton.css";

const WhatsAppButton = ({
  phoneNumber = "918800954675",
  message = "Hello Dazbog, I would like to inquire about your renewable energy services."
}) => {
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
      title="Chat with us on WhatsApp"
    >
      <span className="whatsapp-pulse-ring" />
      <BsWhatsapp className="whatsapp-icon" />
    </a>
  );
};

export default WhatsAppButton;
